
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import DateRange from '@/components/DateRange.vue';
import api from '@/api';
import Util from '@/utils/util';

const { merchantcategory, merchant, report } = api;

@Component({
  components: { DateRange },
})
export default class PaymentList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private headers = [
    { text: '會員編號', value: 'userId' },
    { text: '外部ID', value: 'userIdPublic', with: '30px' },
    { text: '會員姓名', value: 'fullName', with: '30px' },
    { text: '訂單日期', value: 'createdOn', with: '30px' },
    { text: '訂單編號', value: 'transactionId' },
    { text: '供應商', value: 'merchantName' },
    { text: '類型', value: 'productTypeName' },
    { text: '品項名稱', value: 'productName' },
    { text: '訂單數量', value: 'quantity' },
    { text: '點數', value: 'usePoint' },
    { text: '現金', value: 'payAmount' },
    { text: '發票', value: 'invoiceNo' },
    { text: '手續費', value: 'serviceFee' },
    { text: '運費', value: 'shippingFee' },
    { text: '收件人', value: 'receiver' },
    { text: '連絡電話', value: 'mobile' },
    { text: '收件人地址', value: 'address' },
    { text: '點數回饋', value: 'pointBack' },
  ];

  private merchantCategories: Array<{ text: string; value: string}> = [];

  private merchants: Array<{categoryId: string; text: string; value: string }> = [];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    merchantCategoryId: this.$route.query.merchantCategoryId || undefined,
    merchantId: this.$route.query.merchantId || undefined,
    userId: this.$route.query.userId || undefined,
    userIdPublic: this.$route.query.userIdPublic || undefined,
    transactionId: this.$route.query.transactionId || undefined,
    startDate: this.$route.query.startDate || this.getFirstDayOfCurrentMonth(),
    endDate: this.$route.query.endDate || undefined,
  };

  private pager = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private getFirstDayOfCurrentMonth() {
    const date = new Date();
    return `${date.getFullYear()}-${date.getMonth() + 1}-01`;
  }

  private async updatePage(page: number) {
    this.pager.pageNo = page;
    await this.query();
  }

  private async search() {
    this.pager.pageNo = 1;
    await this.query();
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.pager.pageSize}`,
      pageNo: `${this.pager.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    }
    await this.requestData();
  }

  private async reset() {
    this.filter = {
      merchantCategoryId: undefined,
      merchantId: undefined,
      userId: undefined,
      userIdPublic: undefined,
      transactionId: undefined,
      startDate: this.getFirstDayOfCurrentMonth(),
      endDate: undefined,
    };
    this.pager = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async exportCsv() {
    this.loading = true;
    const { status, data } = (await report.exportPayment(this.filter)) || {};
    this.loading = false;
    if (status === 0) return;
    Util.saveFile(data, '訂單清單.txt');
  }

  private BindMerchant(id: any) {
    const merchants = this.merchants.filter((p) => p.categoryId === id);
    return [{ categoryId: '', text: '全部', value: '' }, ...merchants];
  }

  private async requestFilterDropDownList() {
    await this.SetCategory();
    await this.SetMerchant();
  }

  private async SetCategory() {
    const { data: { data } } = (await merchantcategory.list({ pageNo: 1 })) || {};
    if (!!data) {
      const categories: Array<{ text: string; value: string }> = data.map(
        (v: any) => ({ text: v.categoryName, value: v.categoryId }),
      );
      this.merchantCategories = [{ text: '全部', value: '' }, ...categories];
    }
  }

  private async SetMerchant() {
    const { data } = (await merchant.list()) || {};
    if (!!data) {
      const merchants: Array<{ categoryId: string; text: string; value: string }> = data.map(
        (v: any) => ({ categoryId: v.categoryId, text: v.merchantName, value: v.merchantId }),
      );
      this.merchants = merchants;
    }
  }

  private async requestData() {
    this.loading = true;
    const filter = { ...this.pager, ...this.filter };
    const { data } = await report.listPayment(filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: PaymentList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestFilterDropDownList();
      await vm.requestData();
    });
  }
}
